import classNames from "classnames";
import { forwardRef } from "react";

import { FieldGroupPrepend as StyledPrepend } from "../FieldGroup.styled";
import { FieldGroupProps } from "../";

const FieldGroupPrepend = forwardRef<HTMLDivElement, FieldGroupProps>((props, ref) => {
  const { className, ...restProps } = props;
  const fieldGroupPrependClass = classNames("c-field-group__prepend", className);

  return (
    <StyledPrepend data-testid="qa-field-group-prepend" ref={ref} className={fieldGroupPrependClass} {...restProps} />
  );
});

export default FieldGroupPrepend;
